<template>
  <div>
    <div class="flex-container" :style="skin.header_desktop.nav_bar" id="main_nav">
      <div class="c1">
        <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo">
      </div>
      <div class="c2" :style="skin.header_desktop.nav_bar_text">
        <div v-for="(item, index) in filteredCategories" :key="index" @click="change_view(index)" class="options"
          style="display: flex; flex-direction: column; gap:5px;">
          <i v-if="item.category === 'lobby'" class="fa fa-home"></i>
          <span> {{ translate(item.name) }} </span>
        </div>
      </div>
      <div v-if="user.token == ''" class="c3">
        <div v-if="skin.register" @click="site == '86174' ? register2() : register()" class="style" :style="skin.header_desktop.register_btn">
          {{ translate("sign_in") }}
        </div>
        <div v-if="skin.login" @click="login" class="style" :style="skin.header_desktop.login_btn">
          {{ translate("log_in") }}
        </div>
      </div>
      <div v-if="user.token != ''" class="c4">
        <div v-if="user.token != '' && skin.auto_payment?.enabled" @click="payment"
          :style="skin.header_desktop.login_btn" class="btn btn-sm text-end mx-1 d-flex align-items-center">
          <i class="fas fa-plus fa-fw me-1" style="font-size: 14px;"></i> <!-- Ícono de depósito -->
          <span style="font-size: 12px;">DEPOSIT</span> <!-- Texto de depósito -->
        </div>

        <div v-if="user.token != '' && skin.auto_payment?.enabled" @click="withdraw"
          :style="skin.header_desktop.login_btn" class="btn btn-sm text-end mx-1 d-flex align-items-center">
          <i class="fas fa-minus fa-fw me-1" style="font-size: 14px;"></i> <!-- Ícono de retiro -->
          <span style="font-size: 12px;">WITHDRAW</span> <!-- Texto de retiro -->
        </div>
        <div class="py-0 pb-0 px-2 pe-2 text-center">
          <div>
            <!-- <div v-if="user.site_id == 86174">
              <span class="options">
                {{ user.user_data.data ? new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: skin.qBet_config.decimalsQty,
                  maximumFractionDigits: skin.qBet_config.decimalsQty
                }).format(user.user_data.data.balance) + ' ' + user.user_data.data.currency : 0 }}
              </span>
            </div> -->
            <div>
              <div v-if="skin.conversion ? (skin.conversion.enabled ? true : false) : false">
                <span>
                  {{ user.user_data.data ? new Intl.NumberFormat("de-DE").format(
                    balanceParsed(balance.saldo, currency.fiat), {
                    minimumFractionDigits: skin.qBet_config.decimalsQty,
                    maximumFractionDigits: skin.qBet_config.decimalsQty
                  }
                  ) + ' ' + currency.fiat : 0 }}
                </span>
              </div>

              <span class="options">
                {{ user.user_data.data ? new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: skin.qBet_config.decimalsQty,
                  maximumFractionDigits: skin.qBet_config.decimalsQty
                }).format(balance.saldo) + ' ' + user.user_data.data.currency : 0 }}
              </span>
            </div>
          </div>
        </div>

        <div style="cursor:pointer;" class="py-1 me-2 pb-1 px-2 pe-2 text-center nav-item dropdown">
          <a :style="skin.header_desktop.nav_bar_text" class="nav-link dropdown-toggle options" href="#"
            id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {{ translate("services") }}
          </a>
          <div :style="skin.header_desktop.servicios" class="dropdown-menu" aria-labelledby="navbarDropdown">
            <div class="px-2 pe-2">
              <span :style="skin.header_desktop.servicios_text">{{ user.user_data.data ? user.user_data.data.name : ''
              }}</span><br>
              <hr class="m-1 p-0" style="color:white">
            </div>
            <div class="px-2 pe-2 p-1" :style="skin.header_desktop.servicios_text2" @click="openMyAccountModal">
              <span>{{ translate("my_account") }}</span>
            </div>
            <div @click="terms" class="px-2 pe-2 p-1" :style="skin.header_desktop.servicios_text2">
              <span>{{ translate("terms_and_conditions") }}</span>
            </div>
            <div v-if="skin.logout" @click="chanpass" class="px-2 pe-2 p-1"
              :style="skin.header_desktop.servicios_text2">
              <span>{{ translate("change_password") }}</span>
            </div>
            <div v-if="skin.logout" @click="logout" class="px-2 pe-2 p-1" :style="skin.header_desktop.servicios_text2">
              <span>{{ translate("leave") }}</span>
            </div>
          </div>
        </div>
        <div style="cursor:pointer;" class="px-2 pe-2 text-center nav-item dropdown">
          <language-selector v-bind:skin="skin" v-bind:language="language" />
        </div>
      </div>
      <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login"
        style="display:none;"></button>
      <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
        style="display:none;"></button>
      <button id="register_btn2" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggleEu"
        style="display:none;"></button>
      <button id="payment_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#payment"
        style="display:none;"></button>
      <button id="withdraw_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#withdraw"
        style="display:none;"></button>
      <payment v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
      <withdraw v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
      <login v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
      <button id="chanpass_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#changePassword"
        style="display:none;"></button>
      <change-password v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation"
        v-bind:user="user" />
      <register ref="register" v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
      <register_eujogo ref="register" v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
    </div>
    <div class="modal-container" v-if="displayModal">
      <div class="modal-root">
        <myAccount v-bind:language="language" v-bind:translation="translation">
        </myAccount>
      </div>
    </div>
    <account-access-auth-modal v-bind:show="showAccountAuthModal" v-bind:skin="skin" v-bind:language="language"
      v-bind:translation="translation" @close="showAccountAuthModal = false" @verified="handleAccountVerified" />
  </div>
</template>

<script>
import myAccount from "./my_account.vue";
import withdraw from "../../payments/withdraw.vue";
import payment from "../../payments/payment.vue";
import login from "./login.vue";
import register from './register.vue';
import register_eujogo from './register_eujogo.vue';
import changePassword from './change_password.vue';
import languageSelector from './language.vue';
import AccountAccessAuthModal from './AccountAccessAuthModal.vue';
export default {
  name: "Header",
  props: ['skin', 'language', 'translation'],
  data() {
    return {
      displayModal: false,
      showAccountAuthModal: false,
      balance: {
        saldo: 0,
        conversion: 0,
        view: "SALDO",
        switch: 1
      }
    }
  },
  components: {
    myAccount,
    login,
    payment,
    withdraw,
    register,
    changePassword,
    languageSelector,
    register_eujogo,
    AccountAccessAuthModal,
  },
  methods: {
    openMyAccountModal() {
      const siteId = String(this.$store.getters['getSiteId']);
      const rol = this.user?.user_data?.data?.rol;

      if (siteId === '86085' && rol === 'RESELLER') {
        this.showAccountAuthModal = true;
        return;
      }

      this.$root.$emit('open-my-account-1'); // Emite un evento para abrir el modal
    },
    handleAccountVerified() {
      this.showAccountAuthModal = false;
      this.$root.$emit('open-my-account-1');
    },
    changeBalanceView() {
      let balance = 0;
      let disponible = 0
      if (this.config.SkinConfig.main.newbonus ? this.$store.getters['getConfig'].SkinConfig.main.newbonus : false) {
        balance = this.user.user_data.data.available_balance + this.user.user_data.data.bonus + this.user.user_data.data.frozen;
        disponible = this.user.user_data.data.available_balance;
      }
      else {
        balance = this.user.user_data.data.balance;
        disponible = this.user.user_data.data.bonus_balance;
      }
      let tasa = 1;
      if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
        tasa = this.currency.rate;
      }
      if (this.balance.switch == 0) {
        this.balance.saldo = balance;
        this.balance.conversion = (this.currency.fiat != 'BETC' ? (this.currency.fiat == 'USDT' ? balance * tasa : balance * tasa * this.user.user_data.data.tasa) : balance).toFixed(2);
        this.balance.view = "SALDO";
        this.balance.switch = 1;
      }
      else {
        this.balance.saldo = disponible;
        this.balance.conversion = (this.currency.fiat != 'BETC' ? (this.currency.fiat == 'USDT' ? balance * tasa : balance * tasa * this.user.user_data.data.tasa) : balance).toFixed(2);
        this.balance.view = "DISPONIBLE";
        this.balance.switch = 0;
      }
    },
    login() {
      document.getElementById('login_btn').click();
    },
    register() {
      document.getElementById('register_btn').click();
    },
    register2() {
      document.getElementById('register_btn2').click();
    },
    translate(text) {
      if (text) {
        if (this.$props.translation[text]) {
          return this.$props.translation[text][this.$props.language];
        }
        else {
          var new_text_serched = text.replace(/ /g, "_");
          if (this.$props.translation[new_text_serched]) {
            return this.$props.translation[new_text_serched][this.$props.language];
          }
        }
        return text;
      }
    },
    change_view(view) {
      this.$store.dispatch("changeView", view);
    },
    payment() {
      document.getElementById('payment_btn').click();
      this.$store.dispatch('setPayment')
    },
    withdraw() {
      document.getElementById('withdraw_btn').click();
      this.$store.dispatch('setPayment2')
      this.$store.dispatch('setWithdraw')
    },
    chanpass() {
      document.getElementById('chanpass_btn').click();
    },
    logout() {
      this.$store.dispatch('logOut');
      this.$root.$emit('forceRender');
    },
    terms() {
      let url = "";
      let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
      if (this.user.prefix == "external") {
        url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
      }
      else {
        let domain_formated = this.user.domain.split('//')[1];
        //let domain_formated = "admin.championred.bet";
        let domain_name1 = domain_formated.split('.')[1].toUpperCase();
        let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
        url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
      }

      window.open(url, '_blank').focus();
    }
  },
  computed: {
    filteredCategories() {
      let filtro = this.$props.skin.categories.filter(category => category.active);
      // console.log(filtro);
      return filtro;
    },
    site(){
      return this.$store.getters['getSite'];
    },  
    currency() {
      return this.$store.getters['getCurrency'];
    },
    config() {
      return this.$store.getters['getConfig'];
    },
    header_productsQty() {
      let products = [this.$props.skin.poker, this.$props.skin.prematch, this.$props.skin.casinoN, this.$props.skin.casino_live, this.$props.skin.hipicas, this.$props.skin.login, this.$props.skin.logout];
      return products.filter(x => x == true).length + 1;
    },
    user() {
      let config = this.$store.getters['getConfig'];
      let data = this.$store.getters['getUserData'];
      if (data.user_data.data) {
        this.balance.saldo = config.SkinConfig.main.newbonus ? data.user_data.data.available_balance + data.user_data.data.bonus + data.user_data.data.frozen : data.user_data.data.balance;
        this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
      }
      return data;
    }
  },
  mounted() {
    this.$root.$on("open-my-account-1", () => {
      this.displayModal = !this.displayModal;
    });
    this.$root.$on('openLogin', () => {
      this.login();
    });
    this.$store.dispatch("setHeaderHeight", document.getElementById("main_nav").offsetHeight);
  },
  created() {
    let self = this;
    let balanceRequestTime = 8000;
    var saldo_request = setInterval(function () {
      try {
        if (self.$store.getters["getUserData"].user_data.data ) {
          self.$store.dispatch("getUserData", {
            token: self.user.token,
            site_id: self.user.site_id,
            site: self.user.site,
            prefix: self.user.prefix,
            source: "main",
          });
        } else if(self.user.user_data.data) {
          self.$store.dispatch('getProfile', {
            token: self.user.token,
            site_id: self.user.site_id,
            site: self.user.site,
            prefix: self.user.prefix,
            playerId: self.user.user_data?.data?.user_id,
            source: "main"
          });
        }
      } catch (error) {
        this.$store.dispatch('logOut');
        clearInterval(saldo_request);
      }
    }, balanceRequestTime);
  },
  beforeDestroy() {
    this.$root.$off('open-my-account-1');
    this.$root.$off('openLogin');
  }
};


</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Fondo semitransparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  /* Asegura que esté sobre otros elementos */
}

.modal-root {
  border-radius: 8px;
  width: 100%;
  max-width: 100%;
  /* Establece un ancho máximo fijo */
  height: 90%;
  /* Altura fija relativa al viewport */
  overflow-y: auto;
  /* Activa scroll cuando el contenido excede la altura fija */
  transform: scale(0.9);
  font-size: 20px;
  animation: modalAppear 0.3s ease-out forwards;
}

.flex-container {
  display: flex;
  height: 65px;
  padding: 12.25px 0;
}

.c1 {
  width: 17%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* Cambiado de align-content a align-items */
}

.c1 img {
  max-width: 100%;
  /* Asegura que la imagen no se desborde horizontalmente */
  max-height: 100%;
  /* Asegura que la imagen no se desborde verticalmente */
  object-fit: contain;
  /* Ajusta la imagen dentro del contenedor sin distorsión */
}

.c2 {
  width: 63%;
  display: flex;
  justify-content: center;
  align-content: center;
}

.c3 {
  width: 20%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.c4 {
  width: 20%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.options {
  --tw-shadow-color: rgba(0, 0, 0, 0.5);
  font-family: "Poppins";
  max-width: 140px;
  font-weight: 700;
  font-style: inherit;
  font-size: 11.5px;
  padding: 0 7px;
  border-radius: 10.5px;
  line-height: 11.2px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  user-select: none;
}

.options:hover {
  --tw-shadow: inset 0 0 8px rgba(0, 0, 0, 0.3);
  --tw-ring-offset-shadow: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-shadow);
  /* box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.3),
              0 0 8px rgba(0, 0, 0, 0.5); */
}

.style {
  display: flex;
  font-family: "Poppins", sans-serif;
  font-size: 12.25px;
  padding: 0 14px;
  border-radius: 11.2px;
  height: 100%;
  margin-right: 13px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.style:hover {
  transform: scale(1.1);
  /* Aumenta ligeramente el tamaño */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);
  /* Sombra suave */
}
</style>
